import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionCartDeliveryInstruction = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CART_DELIVERY_INSTRUCTION,
    });
};

export const impressionNoAddressSelected = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_NO_ADDRESS_SELECTED,
    });
};

export const impressionDeliveryInstructionSubtext = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CART_DELIVERY_INSTRUCTION_SUBTEXT,
    });
};

export const clickDeliveryInstructionItem = (
    instruction: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: `${CLICK_ACTIONS.CLICK_DELIVERY_INSTRUCTION}-${instruction}`,
    });
};

export const impressionDirectionsToReachCard = (
    context: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_DIRECTIONS_TO_REACH_CARD,
        context,
    });
};

export const clickDirectionsToReachCard = (
    instruction: string,
    context: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: `${CLICK_ACTIONS.CLICK_DELIVERY_INSTRUCTION}-${instruction}`,
        context,
    });
};

export const impressionVoiceDirectionTooltip = (
    context: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_VOICE_DIRECTIONS_TOOLTIP,
        context,
    });
};

export const clickDeliveryInstructionCrouton = (
    cartId: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_DELIVERY_INSTRUCTION_CROUTON,
        context: cartId,
    });
};

export const impressionDeliveryInstructionCrouton = (
    cartId: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_DELIVERY_INSTRUCTION_CROUTON,
        context: cartId,
    });
};
